import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarFilterItem from '../VeltCommentsSidebarFilterItem/VeltCommentsSidebarFilterItem';
import VeltCommentsSidebarFilterName from '../VeltCommentsSidebarFilterName/VeltCommentsSidebarFilterName';
import VeltCommentsSidebarFilterSearch from '../VeltCommentsSidebarFilterSearch/VeltCommentsSidebarFilterSearch';
var VeltCommentsSidebarFilterStatus = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-status-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterStatus.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterStatus.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterStatus.Search = VeltCommentsSidebarFilterSearch;
export default VeltCommentsSidebarFilterStatus;
